import React from 'react';
import makeCarousel from 'react-reveal/makeCarousel';
import styled from 'styled-components';
import images from 'rc-images';

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 65%;
  height: 200px;
  margin-left: 18%;

  @media screen and (min-width: 610px) and (max-width: 767px) {
    width: 55%;
    height: 280px;
    margin-left: 22%;
  }

  @media screen and (min-width: 559px) and (max-width: 609px) {
    width: 61%;
    height: 280px;
    margin-left: 18%;
  }

  @media screen and (min-width: 441px) and (max-width: 558px) {
    width: 63%;
    height: 280px;
    margin-left: 18%;
  }

  @media screen and (min-width: 320px) and (max-width: 440px) {
    width: 60%;
    height: 280px;
    margin-left: 19%;
  }
`;

const LeftArrow = styled.button`
  text-shadow: 1px 1px 1px #fff;
  z-index: 100;
  text-align: center;
  position: absolute;
  top: 84px !important;
  left: 0;
  font-size: 1em;
  cursor: pointer;
  user-select: none;
  border: none;
  color: #1675b2;
  cursor: pointer;
  background-color: transparent;
  border: none !important;

  &::before{
    content: '';
    position: absolute;
    left: 0 !important;
    top: 0;
    bottom: 0;
    margin: auto !important;
    background-size: contain;
    background-position: center;
    background-image: url(${images.icons.sliderLeftArrow});
    background-repeat: no-repeat;
    background-color: transparent;
    width: 50px;
    height: 50px;
    box-shadow: 2px 0px 7px -6px black;
    border-radius: 50px;
    margin-left: -17px;
    
    @media screen and (max-width: 359px) {
      margin: 82px -18px;
    }
  }
  &::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none !important;
  }

  &:hover{
    color: #104e76;
  }

  @media screen and (max-width: 359px) {
    margin-top: -90px !important;
  }

`;

const RightArrow = styled.button`
text-shadow: 1px 1px 1px #fff;
z-index: 100;
text-align: center;
position: absolute;
top: 84px !important;
right: 0 !important;
font-size: 1em;
cursor: pointer;
user-select: none;
border: none !important;
color: #1675b2;
cursor: pointer;
background-color: transparent;
border: none !important;

&::after{
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  background-image: url(${images.icons.sliderRightArrow});
  background-repeat: no-repeat;
  background-color: transparent;
  width: 50px;
  height: 50px;
  box-shadow: -2px 0px 7px -6px black;
  border-radius: 50px;
  margin-right: -17px;

  @media screen and (max-width: 359px) {
    margin: 82px -17px !important;
  }
}
&::-moz-focus-inner {
  border: 0;
}

&:focus {
  outline: none !important;
}


&:hover{
  color: #104e76;
}

@media screen and (max-width: 359px) {
  margin-top: -90px !important;
}

`;

const CarouselUI = ({ position, handleClick, children }) => (
  <div>
    <Container>
      {children}
    </Container>
    <LeftArrow onClick={handleClick} data-position={position - 1} aria-label="previous" value="left-arrow" />
    <RightArrow right onClick={handleClick} data-position={position + 1} aria-label="next" value="right-arrow" />
  </div>
);


const Carousel = makeCarousel(CarouselUI);

export default Carousel;
